module.exports = __webpack_public_path__ + "static/media/keyboard-arrow-up-black-48-dp.dbbeba1d.svg";